import { render, staticRenderFns } from "./PetItem.vue?vue&type=template&id=0788cff2&scoped=true&"
import script from "./PetItem.vue?vue&type=script&lang=js&"
export * from "./PetItem.vue?vue&type=script&lang=js&"
import style0 from "./PetItem.vue?vue&type=style&index=0&id=0788cff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788cff2",
  null
  
)

export default component.exports